import { AbstractPlugin } from '../plugin';

export class SpriteLoader extends AbstractPlugin {
  override name = 'sprite';
}
